import * as React from 'react';

interface ISectionProps {
    type?: string;
    children: any;
}

const Section = (props: ISectionProps) => {
    return (
        <section className={'section' + (props.type ? ' section--' + props.type : '')}>
            {props.children}
        </section>
    );
};

export default Section;



// WEBPACK FOOTER //
// ./src/modules/Section/Section.tsx